import { createVanIconComponent } from "./van"

const Sort = createVanIconComponent("sort")
export default Sort
